<script lang="ts">
  export let isPdp: boolean = false;
</script>

<style lang="scss">
  div {
    max-width: 100%;
    box-sizing: border-box;
    padding: 0 2rem;

    @include breakpoint(md) {
      padding: 0 2.75rem;
    }

    @include breakpoint(lg) {
      padding: 0 3.25rem;
    }

    @include breakpoint(xl) {
      padding: 0 4rem;
    }

    @include breakpoint(xxl) {
      padding: 0 6rem;
    }
  }
</style>

{#if isPdp}
  <slot />
{:else}
  <div {...$$props}>
    <slot />
  </div>
{/if}
